import './portfolio.css';
import  'bootstrap/dist/css/bootstrap.min.css';
import Footer from '../footer/Footer';
import Award from '../award/Award';
import Resume from '../Resume/Resume';
import About from '../About/About';
import Skill from '../Skill/Skill';
import Mysecpic from '../Firstsec/Mysecpic';
import Navb from '../Nav/Nav';
import { Form } from 'react-bootstrap';
const Portfolio=()=>{
    const design=(
        <>  
            
          <Form>
          <Mysecpic/>
                <Navb/>
                <br />
                <br />
               <About/>
                <br /><br />
               <Skill/>
                <br />
                <Award/>
                <br />
                 <Resume/>
                <br /><br /><br />
                <Footer/>
          </Form>
        </>
    )
    return design
}
export default Portfolio;